import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const AllocationsHeader = ({ onNewRequest, title = "My Allocations", showNewRequest = true }) => {
  const theme  = useTheme();
  const t      = theme.custom;
  const isDark = theme.palette.mode === "dark";

  return (
    <Box sx={{
      display: "flex", alignItems: "center",
      justifyContent: "space-between",
      padding: "16px 24px",
      borderBottom: `1px solid ${t.border2}`,
      flexShrink: 0,
    }}>
      {/* Page title */}
      <Typography sx={{
        fontFamily: "'Inter', sans-serif",
        fontSize: "18px", fontWeight: 700,
        color: t.text, letterSpacing: "-0.01em",
      }}>
        {title}
      </Typography>

      {/* Action buttons */}
      <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
        

        {showNewRequest && (
          <Box
            onClick={onNewRequest}
            sx={{
              display: "flex", alignItems: "center", gap: "6px",
              padding: "7px 18px", borderRadius: "4px", cursor: "pointer",
              background: t.accent,
              fontFamily: "'DM Mono', monospace",
              fontSize: "11px", fontWeight: 600,
              color: isDark ? "#060E0D" : "#fff",
              transition: "opacity 0.15s",
              "&:hover": { opacity: 0.88 },
            }}
          >
            + New Allocation Request
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AllocationsHeader;